<template>
  <div class="base-input">
    <label v-if="label" class="base-input__label">{{ label }}</label>
    <div class="container">
      <div class="container__left">
        <input class="input-text input-text__field" :class="{ 'size-sm': isSmall }"
          :value="modelVal" @input="modelVal = $event.target.value" :placeholder="placeholder" type="text" autocomplete="off"/>
      </div>
      <!-- <div class="container__right" v-if="hasSearchListener">
        <Button class="search" iconGroup="fas" iconName="search" @click="$emit('search')" />
      </div> -->
    </div>
  </div>
</template>

<script>
import VueNumeric from "vue-numeric";
import Constants from "@/resources/Constants";
import Button from "@/components/Base/Button/Button.vue";

export default {
  name: "AppInputControl",
  components: {
    // VueNumeric,
    // Button,
  },
  data() {
    return {
      focused: false,
      Constants,
    };
  },
  props: {
    controlType: {
      type: String,
      default: "input",
    },
    label: {
      type: String,
    },
    precision: {
      type: Number,
    },
    prefix: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    suffix: {
      type: String,
      default: "",
    },
    value: {},
    applyFocus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // listeners() {
    //   const { input, ...listeners } = this.$listeners;
    //   return listeners;
    // },
    // hasSearchListener() {
    //   return this.$listeners && this.$listeners.search;
    // },
    modelVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("updateModel", val);
      },
    },
  },
  mounted() {
    // if (this.applyFocus) {
    //   if (this.controlType === "money") {
    //     this.$nextTick(() => this.$refs.moneyDiv.focus());
    //   } else if (this.controlType === "input") {
    //     this.$nextTick(() => this.$refs.inputDiv.focus());
    //   } else if (this.controlType === "textarea") {
    //     this.$nextTick(() => this.$refs.textareaDiv.focus());
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./_input.scss";
</style>
